enum SnowflakeDeliveryReportType {
  ContentNetworkDelivery = 'CONTENT_NETWORK_DELIVERY',
  ContentChannelDelivery = 'CONTENT_CHANNEL_DELIVERY',
}

export default SnowflakeDeliveryReportType;
